import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SOCIOSSEGUIMIENTO_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function SociosSeguimientoPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SOCIOSSEGUIMIENTO_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
